import React, { useState } from 'react';
import { InputForm, Button } from '../../components';
import Swal from 'sweetalert2';
const Contact = () => {
    const [payload, setPayload] = useState({
        name: '',
        phone: '',
        content: '',
    });
    const handleSubmit = () => {
        Swal.fire(
            `Cảm ơn ${payload.name ? payload.name : ''}`,
            'Phản hồi của bạn đã được chúng tôi ghi nhận',
            'success',
        ).then(() => {
            setPayload({
                name: '',
                phone: '',
                content: '',
            });
        });
    };
    return (
        <div>
            <h1 className="text-2xl font-semibold mb-6">Liên hệ với chúng tôi</h1>
            <div className="flex gap-4">
                <div className=" flex-1 flex flex-col gap-4 p-4 text-white rounded-3xl bg-gradient-to-br from-blue-700 to-cyan-400 ">
                    <h4>Thông tin liên hệ</h4>
                    <span>Man Utd buộc Liverpool chia điểm ở Ngoại hạng Anh</span>
                    <span>Điện thoại: 01233353535</span>
                    <span>Email: vad24042002@gmail.com</span>
                    <span>Zalo: 0921154051</span>
                    <span>Viber: 0022424224</span>
                    <span>Man Utd buộc Liverpool chia điểm ở Ngoại hạng Anh</span>
                </div>
                <div className="flex-1">
                    <h4>Liên hệ trực tuyến</h4>
                    <div>
                        <InputForm
                            label="HỌ VÀ TÊN CỦA BẠN"
                            value={payload.name}
                            setValue={setPayload}
                            keyPayload="name"
                        />
                        <InputForm
                            label="SỐ ĐIỆN THOẠi"
                            value={payload.phone}
                            setValue={setPayload}
                            keyPayload="phone"
                        />
                        <div>
                            <label htmlFor="desc">NỘI DUNG MÔ TẢ </label>
                            <textarea
                                className="outline-none bg-[#e8f0fe] p-2 rounded-md w-full"
                                id="desc"
                                cols="30"
                                name="çontent"
                                onChange={(e) => setPayload((prev) => ({ ...prev, content: e.target.value }))}
                                rows="5"
                            ></textarea>
                        </div>
                        <Button
                            text="Gửi liên hệ"
                            bgColor="bg-blue-500"
                            textColor="text-white"
                            fullWidth
                            onClick={handleSubmit}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
